import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    online: true,
    user: null,
    auth: false,
    time: 0,
    signature_modal: {
      title: "",
      pin: "",
    },
    edited_location: {},
    task_table_state:null,
    mode:1,
    appModes: [
      {"mode":1,"logo":"esafety-logo.svg"},
      {"mode":2,"logo":"efeladatok-logo.svg"},
      {"mode":3,"logo":"enaplo-logo.svg"},
      {"mode":4,"logo":"eadmin-logo.svg"}
    ],
    locationslinear: [],
    positions: [],
    logoutInProgressInCurrentTab: false,
  },
  mutations: {
    updateMode(state, value) {
      state.mode = value;
    },
    updateTaskTableState(state, value) {
      state.task_table_state = value;
    },
    updateTime(state, value) {
      state.time = value;
    },
    updateUser(state, value) {
      state.user = value;
    },
    updateAuth(state, value) {
      state.auth = value;
    },
    updateUserProperty(state, property, value) {
      state.user[property] = value;
    },
    updateSignatureModal(state, value) {
      state.signature_modal = value;
    },
    updateSignatureModalTitle(state, value) {
      state.signature_modal.title = value;
    },
    updateSignatureModalPin(state, value) {
      state.signature_modal.pin = value;
    },
    updateOnline(state, value) {
      state.online = value;
    },
    updateEditedLocation(state, value) {
      state.edited_location = value;
    },
    updateLocationsLinear(state, value) {
      state.locationslinear = value;
    },
    updatePositions(state, value) {
      state.positions = [...value];
    },
    updateLogoutInProgressInCurrentTab(state, value) {
      state.logoutInProgressInCurrentTab = value;
    },
  },
});
